// Mantis #1378 — M001-D029 §4 (F0306, T-M001-RASYNC-003/014): the add-person
// picker offers EXACTLY the RealmAuthority-published people directory of the
// installation the group belongs to. There is no prop, code path or fallback
// that could feed Core's organisation roster into this control: the only data
// source is the directory passed by the caller, keyed by objectSid.
import React from 'react';

const optionLabel = (person) => {
  const name = person.displayName || person.samAccountName || person.upn;
  const badge = person.alsoCoreAccount ? ' (also a Core account)' : '';
  return `${name} — ${person.upn}${badge}`;
};

export default function DirectoryPicker({ directory = [], value, onChange, disabled = false, id = 'ra-directory-picker' }) {
  return (
    <label className="ra-picker" htmlFor={id}>
      Add a person from the RealmAuthority directory
      <select
        id={id}
        data-testid="ra-directory-picker"
        value={value}
        disabled={disabled || !directory.length}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="">{directory.length ? 'Choose a person' : 'The people directory has not been published yet'}</option>
        {directory.map((person) => (
          <option key={person.objectSid} value={person.objectSid}>
            {optionLabel(person)}
          </option>
        ))}
      </select>
    </label>
  );
}
